module.exports = __webpack_public_path__ + "media/images/ZenBG-22e0ef3f367755c42d89d35d553c2bf3.png";